import { Component,OnInit } from '@angular/core';
import {BattezzatiService} from '../services/battezzati.service';
import {Battezzato} from '../beans/battezzato';

@Component({
  selector: 'catalogo-battezzati-component',
  templateUrl: './catalogo-battezzati.component.html',
  styleUrls: ['./catalogo-battezzati.component.css']
})
export class CatalogoBattezzatiComponent implements OnInit {
  
  battezati:Battezzato[];

  constructor (private battezzatiService:BattezzatiService){}

  ngOnInit():void{
  	this.battezzatiService.getBattezzati().then(battezzati=>this.battezati=battezzati);
  }
}


// WEBPACK FOOTER //
// /Users/paspao/workspaceForMaven/libri/libriweb/src/app/catalogo/catalogo-battezzati.component.ts